<div class="feature-management-header">
  <h2>Fonctionnalités</h2>
</div>
<div class="feature-management-body">
  <div class=feature-management-table>
    <div *ngIf="displayType === typeTmpl.GLOBAL" class="explication">
      Attention:<br><br>Les valeurs d'activation/désactivation des fonctionnalités de ce tableau sont des valeurs par défaut. Elles peuvent être surchargées au niveau des profils et cabinets.
    </div>

    <div class="table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="featureLabel">
          <th mat-header-cell *matHeaderCellDef> Fonctionnalité </th>
          <td mat-cell *matCellDef="let feature"> {{feature.label}} </td>
        </ng-container>

        <ng-container matColumnDef="featureDescription">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let feature"> {{feature.description}} </td>
        </ng-container>

        <ng-container matColumnDef="featureGranularity">
          <th mat-header-cell *matHeaderCellDef> Granularité </th>
          <td mat-cell *matCellDef="let feature">
            <!-- <input type="radio" [name]="feature.type" (change)="changeGranularity(feature, $event)"> -->
            <!-- <select (change)="changeGranularity(feature, $event)">
              <option *ngFor="let granularity of granularities" [value]="granularity.value" [selected]="feature.type === granularity.value">{{ granularity.label }}</option>
            </select> -->

            <div class="ngselect-container">
              <ng-select dropdownPosition="bottom" [clearable]="false" [items]="granularities"
                closeOnSelect="true" bindLabel="label" bindValue="value"
                class="input" [(ngModel)]="feature.type">
              </ng-select>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="featureValueTrue">
          <th mat-header-cell *matHeaderCellDef class="center"> Activée </th>
          <td mat-cell *matCellDef="let feature" class="center">
            <input type="radio" [name]="feature.key" [checked]="feature.value" value="true" (click)="changeValue(feature, true)">
          </td>
        </ng-container>

        <ng-container matColumnDef="featureValueFalse">
          <th mat-header-cell *matHeaderCellDef class="center"> Désactivée </th>
          <td mat-cell *matCellDef="let feature" class="center">
            <input type="radio" [name]="feature.key" [checked]="!feature.value" value="false" (click)="changeValue(feature, false)">
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
    </div>

    <div class="buttons-wrapper">
      <frg-button (click)="updateFeatures()">Enregistrer</frg-button>
    </div>
  </div>
</div>